import { AppSetting } from 'dependencies/appsettings';
import { BlobResponse, createUploader, RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoints } from '../../endpoints';
import { ListApiGateway } from '../types';
import { TextsListWire } from './types';
import { ModifiedText, ModifiedTextWire, TextListMetadata, TextSearchData, TextSearchModel } from './types-store';

export const api = {

  getTextsList: async (startIndex: number, maxResults: number, model: TextSearchModel): Promise<TextsListWire> => {

    const response: any = await new RemoteAdminData(endpoints.searchTexts)
      .resource<ApiResponse<TextsListWire>>()
      .filter({ startIndex, maxResults })
      .create(model, false);

    const json: ApiResponse<TextsListWire> = await response.json();
    return json.data;
  },

  saveChanges: (modifiedTexts: ModifiedTextWire[]) => {
    return new RemoteAdminData(endpoints.saveTexts)
      .resource<void>()
      .update(modifiedTexts);
  },

  exportToExcel: async (startIndex: number, maxResults: number, model: TextSearchModel): Promise<BlobResponse> => {
    return await new RemoteAdminData(endpoints.exportToExcel)
      .resource<BlobResponse>()
      .filter({ startIndex, maxResults })
      .blob(model);
  }
};

export const textApiGateway: ListApiGateway<TextListMetadata, TextSearchData, ModifiedText, TextSearchModel> = {

  getMetadata: () => {
    return Promise.resolve({});
  },

  getList: (startIndex: number, maxResults: number, model: TextSearchModel) => {

    return api.getTextsList(startIndex, maxResults, model);
  },

  saveChanges: (modifiedTexts: ModifiedText[]) => {
    const modifiedTexstWire = modifiedTexts
      .filter(text => !text.onlyWhitespace)
      .map(text => ({
        id: text.id,
        textSet: text.textSet,
        language: text.language,
        text: text.text.trim()
      }));

    return api.saveChanges(modifiedTexstWire);
  },

  exportToExcel: (startIndex: number, maxResults: number, model: TextSearchModel): Promise<BlobResponse> => {

    return api.exportToExcel(startIndex, maxResults, model);
  },

  createUploadRequest: () => {
    return createUploader(`${endpoints.importFromExcel}?api-version=1.0`, 'POST', AppSetting.AdminApiBaseUrl);
  }
};
